import React, { useState, useEffect } from "react";
import useChatGPT from "../../Hooks/useChatGPT";
import classes from "./styles.module.scss";
import {text} from "./constants.js"
import useToast from "../../Hooks/useToast";

export const ChatGPT= () => {
    const {showToast} = useToast();
    const { data , done, start, prompt, setData, setDone } =  useChatGPT();
    const [loading, setLoading] = useState(false);
    const [inputText, setInputText] = useState('')

    const handleSubmit = () => {
        let data = {
            query: inputText,
        }
        prompt(data).catch(err=>{
            console.log(err)
            showToast(text.errorMsg, 'error')
        });
        setLoading(true)
    }

    useEffect(()=>{
        if(done){
            setLoading(false)
            setDone(false)
        }
    }, [data, done])

    return (
        <div className={classes.container}>
            <h1>{text.pageTitle}</h1>
            <div className={classes.answerContainer}>
                {data ? data.split("\n").map((line, key) => {
                return <p key={key}>{line}</p>;
                })  : "Hi! How can I assist you today?"}
            </div>
            <div className={classes.formContainer}>
                <input className={classes.input} onChange={(e)=>setInputText(e.target.value)} placeholder="Enter Prompt Here" />
                <button disabled={loading} className={`${classes.button} ${loading && classes.buttonDisabled}`} onClick={handleSubmit}>get</button>
            </div>
        </div>
    );
}
